import React, { useEffect, useState } from 'react'


const KinoheldIFrame = ({
    cinemaPath,
    showId,
    baseUrl
}) => {
    const initIFrame = () => {
        const script = document.createElement("script");
        script.src = "https://www.kinoheld.de/dist/eframe/eframe.min.js";
        script.async = true;
        script.onload = () => {
            window.kinoheldEframe.init({
                cinemaPath: cinemaPath,
                design: 'new',
                baseUrl: baseUrl,
                rb: false,
                showId: showId,
                element: 'iframe-id-' + showId
            });
        }
        document.body.appendChild(script);
    }
    
    const openIFrame = () => {
        window.kinoheldEframe.init({
            cinemaPath: cinemaPath,
            design: 'new',
            baseUrl: baseUrl,
            rb: false,
            showId: showId,
            element: 'iframe-id-' + showId
        });
    }
    
    const changeShow = () => {
        window.kinoheldEframe.updateConfig({
            showId: showId,
            element: 'iframe-id-' + showId
        });
    }
    
    const [iframeIsOpen, setIframeIsOpen] = useState(false)
    useEffect(() => {
        if(!iframeIsOpen && !window.kinoheldEframe){
            setIframeIsOpen(true)
            initIFrame()
        } else if(!iframeIsOpen && window.kinoheldEframe) {
            setIframeIsOpen(true)
            openIFrame()
        } else {
            changeShow()
        }
    }, [showId]);
    
    return (
        <div className="theme-radius-posters-full kinoheld-eframe" id={'iframe-id-' + showId}></div>
    )
}

export default KinoheldIFrame